export const UserType = {
  OWNER: 'owner',
  EDITOR: 'editor',
  VIEWER: 'viewer',
  // Deprecated alias — use EDITOR instead.
  COLLABORATOR: 'editor',
};
